import "core-js/modules/es.function.name";
import TIM from 'tim-js-sdk';
import TIMUploadPlugin from 'tim-upload-plugin';
import store from './store'; // 初始化 SDK 实例

var tim = TIM.create({
  SDKAppID: process.env.VUE_APP_IM_SDK_ID
});
window.setLogLevel = tim.setLogLevel; // 设置 SDK 日志输出级别，详细分级请参见<a href="https://web.sdk.qcloud.com/im/doc/zh-cn//SDK.html#setLogLevel">setLogLevel 接口的说明</a>
// tim.setLogLevel(0) // 普通级别，日志量较多，接入时建议使用

tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用
// 注册 cos

tim.registerPlugin({
  'tim-upload-plugin': TIMUploadPlugin
});
tim.on(TIM.EVENT.SDK_READY, function (_ref) {
  var name = _ref.name;
  var isSDKReady = '';

  if (name === TIM.EVENT.SDK_READY) {
    isSDKReady = true;
  } else {
    isSDKReady = false;
  }

  store.commit('chatUser/toggleIsSDKReady', isSDKReady);

  if (isSDKReady) {
    tim.getMyProfile().then(function (_ref2) {
      var data = _ref2.data;
      store.commit('chatUser/updateCurrentUserProfile', data);
    }).catch(function (error) {
      console.log('errol', error);
    });
    tim.getConversationList().then(function (event) {
      store.commit('conversation/updateConversationList', event.data.conversationList);
    });
  }
}); // SDK NOT READT

tim.on(TIM.EVENT.SDK_NOT_READY, function (_ref3) {
  var name = _ref3.name;
  var isSDKReady = '';

  if (name === TIM.EVENT.SDK_READY) {
    isSDKReady = true;
  } else {
    isSDKReady = false;
  }

  store.commit('chatUser/toggleIsSDKReady', isSDKReady);

  if (isSDKReady) {
    tim.getMyProfile().then(function (_ref4) {
      var data = _ref4.data;
      store.commit('chatUser/updateCurrentUserProfile', data);
    }).catch(function (error) {
      console.log('errol', error);
    });
  }
}); // 被踢出

tim.on(TIM.EVENT.KICKED_OUT, function () {
  store.commit('chatUser/toggleIsLogin', false);
  store.commit('chatUser/reset');
}); // 收到新消息

tim.on(TIM.EVENT.MESSAGE_RECEIVED, function (_ref5) {
  var messageList = _ref5.data;
  console.log('收到新消息');
  store.commit('conversation/pushCurrentMessageList', messageList);
}); // 会话列表更新

tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, function (event) {
  console.log('会话列表更新-------', event.data);
  store.commit('conversation/updateConversationList', event.data);
}); // 网络监测
// tim.on(TIM.EVENT.NET_STATE_CHANGE, function() {
//   store.commit('showMessage', this.checkoutNetState(event.data.state))
// })
// 已读回执

tim.on(TIM.EVENT.MESSAGE_READ_BY_PEER, function (event) {
  console.log('已读回执', event);
  store.commit('conversation/setPeerRead', event);
});
export default tim;